import { LONG_REQUEST_TIMEOUT_MS } from "../../client";
import type { CoreApiClient } from "../client";
import type {
  CreateModuleRequestBody,
  Module,
  ResetModulesRequestBody,
  ResetModulesResult,
  SetMaintenanceRequestBody,
  UpdateModuleRequestBody,
} from "../types/module.type";

export const createModuleMutations = (api: CoreApiClient) => {
  const { request } = api;

  const create = async (buildingId: string, body: CreateModuleRequestBody): Promise<Module> => {
    const { data } = await request("post", "/buildings/{buildingId}/modules", {
      params: { path: { buildingId } },
      body,
    });
    return data;
  };

  const update = async (buildingId: string, moduleId: string, body: UpdateModuleRequestBody): Promise<Module> => {
    const { data } = await request("patch", "/buildings/{buildingId}/modules/{moduleId}", {
      params: { path: { buildingId, moduleId } },
      body,
    });
    return data;
  };

  const deleteModule = async (buildingId: string, moduleId: string): Promise<void> => {
    await request("delete", "/buildings/{buildingId}/modules/{moduleId}", {
      params: { path: { buildingId, moduleId } },
    });
  };

  /** Re-initialize the BMS data of the given modules; blocks on the gateway acknowledgment. */
  const reset = async (buildingId: string, body: ResetModulesRequestBody): Promise<ResetModulesResult> => {
    const { data } = await request("post", "/buildings/{buildingId}/modules/reset", {
      params: { path: { buildingId } },
      body,
      timeout: LONG_REQUEST_TIMEOUT_MS,
    });
    return data;
  };

  /** Enable/disable the module's PLC-maintenance operator SSH access. */
  const setMaintenance = async (
    buildingId: string,
    moduleId: string,
    body: SetMaintenanceRequestBody,
  ): Promise<void> => {
    await request("patch", "/buildings/{buildingId}/modules/{moduleId}/maintenance", {
      params: { path: { buildingId, moduleId } },
      body,
    });
  };

  return {
    create,
    update,
    delete: deleteModule,
    reset,
    setMaintenance,
  };
};
